import styled from "styled-components";
export const Label = styled.span `
  font-size: ${({ theme }) => theme.fontTokens.font13[0]};
  line-height: ${({ theme }) => theme.fontTokens.font13[1]};
  color: ${({ theme }) => theme.colors.grey13};
`;
